import type { ReactNode } from 'react';
import { cn } from '../../lib/cn';
import { Card, CardAction, CardHeader, CardTitle } from './card';
import { InfoDisclosure } from './info-disclosure';

export function OperationalTableCard({
  action,
  actionClassName,
  children,
  className,
  headerClassName,
  information,
  informationLabel,
  notice,
  title,
}: {
  action?: ReactNode;
  actionClassName?: string;
  children?: ReactNode;
  className?: string;
  headerClassName?: string;
  information?: ReactNode;
  informationLabel?: string;
  notice?: ReactNode;
  title: ReactNode;
}) {
  return (
    <Card className={cn('gap-0 overflow-hidden py-0', className)} size="sm">
      {notice}
      <CardHeader className={cn(
        'min-h-14 content-center items-center py-0 pb-0!',
        action && 'grid-cols-[minmax(0,1fr)_auto] grid-rows-1 gap-3',
        headerClassName
      )}>
        <CardTitle className="flex items-center gap-2 text-sm uppercase tracking-wide">
          {title}
          {information ? (
            <InfoDisclosure label={informationLabel ?? 'Section information'}>
              {information}
            </InfoDisclosure>
          ) : null}
        </CardTitle>
        {action ? <CardAction className={cn('col-start-2 row-start-1 row-span-1 w-auto justify-self-end self-center', actionClassName)}>{action}</CardAction> : null}
      </CardHeader>
      {children}
    </Card>
  );
}
